function initCustomVariantPicker(customVariantPickerElement) {
  const customVariantPickerOptionElements = customVariantPickerElement.querySelectorAll(
    '.custom-variant-picker__options li a'
  );
  const customVariantPickerValueElement = customVariantPickerElement.querySelector('.custom-variant-picker__value');
  const productFirstImageElement = document.querySelector(
    '.product__media-wrapper .product__media-list li:first-child .product__media img'
  );

  const data = {
    propName: customVariantPickerValueElement.textContent,
    imageUrl: productFirstImageElement.src,
  };

  let targetPriceClone;

  customVariantPickerOptionElements?.forEach((option) =>
    option.addEventListener('mouseenter', (event) => {
      if (event.target.classList.contains('is-active')) return;

      const productPriceElement = document.querySelector('.product__main-info-wrapper .price');
      const productPriceParentElement = productPriceElement.parentNode;
      const targetParent = event.target.parentNode;
      const targetPrice = targetParent.querySelector('.custom-variant-picker__variant-price .price');
      const { propName, imageUrl } = event.target.dataset;

      targetPriceClone = targetPrice.cloneNode(true);
      productFirstImageElement.src = imageUrl;
      customVariantPickerValueElement.textContent = propName;
      console.log(productPriceElement);
      productPriceElement.classList.add('d-none');
      productPriceParentElement.appendChild(targetPriceClone);
    })
  );

  customVariantPickerOptionElements?.forEach((option) =>
    option.addEventListener('mouseleave', (event) => {
      if (event.target.classList.contains('is-active')) return;

      const productPriceElement = document.querySelector('.product__main-info-wrapper .price');

      productFirstImageElement.src = data.imageUrl;
      customVariantPickerValueElement.textContent = data.propName;
      targetPriceClone.remove();
      productPriceElement.classList.remove('d-none');
    })
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const customVariantPickersElements = document.querySelectorAll('.custom-variant-picker');
  customVariantPickersElements?.forEach((customVariantPickerElement) =>
    initCustomVariantPicker(customVariantPickerElement)
  );
});
